<template>
  <form id="formJurist" class="text-center">
    <v-container fluid>
      <v-row class="pt-6">
        <v-col>
          <h3 class="font-weight-regular">Юридическое лицо</h3>
        </v-col>
      </v-row>
      <v-row class="pt-6">
        <v-col cols=12>
          <v-text-field
            v-model="OPF"
            :error-messages="OPFErrors"
            label="Организационно-правовая форма"
            required
            @input="$v.OPF.$touch()"
            @blur="$v.OPF.$touch()"
            name="OPF"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="JFN"
            :error-messages="JFNErrors"
            label="Полное наименование юр.лица"
            required
            @input="$v.JFN.$touch()"
            @blur="$v.JFN.$touch()"
            name="JFN"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="JN"
            :error-messages="JNErrors"
            label="Сокращенное наименование юр.лица"
            required
            @input="$v.JN.$touch()"
            @blur="$v.JN.$touch()"
            name="JN"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="INN"
            :error-messages="INNErrors"
            label="ИНН"
            type="tel"
            required
            @input="$v.INN.$touch()"
            @blur="$v.INN.$touch()"
            name="INN"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="KPP"
            :error-messages="KPPErrors"
            label="КПП"
            type="tel"
            required
            @input="$v.KPP.$touch()"
            @blur="$v.KPP.$touch()"
            name="KPP"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="JA"
            :error-messages="JAErrors"
            label="Юридический адрес"
            required
            @input="$v.JA.$touch()"
            @blur="$v.JA.$touch()"
            name="JA"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="JA2"
            label="* Почтовый адрес, если отличается"
            name="JA2"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="OGRN"
            :error-messages="OGRNErrors"
            label="ОГРН"
            type="tel"
            required
            @input="$v.OGRN.$touch()"
            @blur="$v.OGRN.$touch()"
            name="OGRN"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="Settlement"
            :error-messages="SettlementErrors"
            label="Рассчетный счет"
            type="tel"
            required
            @input="$v.Settlement.$touch()"
            @blur="$v.Settlement.$touch()"
            name="Settlement"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="Bank"
            :error-messages="BankErrors"
            label="Наименование банка"
            required
            @input="$v.Bank.$touch()"
            @blur="$v.Bank.$touch()"
            name="Bank"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="BankINN"
            :error-messages="BankINNErrors"
            label="ИНН банка"
            type="tel"
            required
            @input="$v.BankINN.$touch()"
            @blur="$v.BankINN.$touch()"
            name="BankINN"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="BankOGRN"
            :error-messages="BankOGRNErrors"
            label="ОГРН банка"
            type="tel"
            required
            @input="$v.BankOGRN.$touch()"
            @blur="$v.BankOGRN.$touch()"
            name="BankOGRN"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="BIK"
            :error-messages="BIKErrors"
            label="БИК"
            type="tel"
            required
            @input="$v.BIK.$touch()"
            @blur="$v.BIK.$touch()"
            name="BIK"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="Correspondent"
            :error-messages="CorrespondentErrors"
            label="Корреспондентский счет"
            type="tel"
            required
            @input="$v.Correspondent.$touch()"
            @blur="$v.Correspondent.$touch()"
            name="Correspondent"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="OKVD"
            :error-messages="OKVDErrors"
            label="ОКВЭД"
            type="tel"
            required
            @input="$v.OKVD.$touch()"
            @blur="$v.OKVD.$touch()"
            name="OKVD"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="OKPO"
            :error-messages="OKPOErrors"
            label="ОКПО"
            type="tel"
            required
            @input="$v.OKPO.$touch()"
            @blur="$v.OKPO.$touch()"
            name="OKPO"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="pt-6">
        <v-col cols=12>
          <h3>Вы представитель компании со стороны заказчика?</h3>
        </v-col>
        <v-col cols=12>
          <div class="buttons mt-6 d-flex justify-center">
            <v-btn dark color="#13bbec" class="hide" :class="{show: !isActiveRepresentative}" @click="isActiveRepresentative = true">Да</v-btn>
            <v-btn dark color="#13bbec" class="hide" :class="{show: isActiveRepresentative}" @click="isActiveRepresentative = false">Скрыть</v-btn>
          </div>
        </v-col>
      </v-row>
      <div class="representativeForm justify-center pt-6" :class="{show: isActiveRepresentative}">
        <v-col cols=12>
          <v-text-field
            v-model="fio"
            :error-messages="fioErrors"
            label="ФИО"
            name="fio"
            required
            @input="$v.fio.$touch()"
            @blur="$v.fio.$touch()"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="post"
            :error-messages="postErrors"
            label="Должность"
            name="post"
            required
            @input="$v.post.$touch()"
            @blur="$v.post.$touch()"
          ></v-text-field>
        </v-col>
        <v-col>
          <h3>Действующий на основании</h3>
          <v-radio-group v-model="radios" :mandatory="false">
            <v-radio label="Устава" value="Устав" @click.native="isActiveAttorney = false"></v-radio>
            <v-radio label="Доверенности" value="Доверенность" @click.native="isActiveAttorney = true"></v-radio>
          </v-radio-group>
        </v-col>
          <div class="attorney" :class="{show: isActiveAttorney}">
            <v-col cols=12>
            <v-text-field
              v-model="attorney"
              :error-messages="attorneyErrors"
              label="Номер доверенности"
              required
              @input="$v.attorney.$touch()"
              @blur="$v.attorney.$touch()"
              name="attorney"
            ></v-text-field>
          </v-col>
          <v-col cols=12>
            <v-text-field
              v-model="attorneyData"
              :error-messages="attorneyDataErrors"
              label="Дата выдачи"
              required
              @input="$v.attorneyData.$touch()"
              @blur="$v.attorneyData.$touch()"
              name="attorneyData"
            ></v-text-field>
          </v-col>
        </div>
        <v-col cols=12>
          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            label="Ваш e-mail"
            required
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
            name="email"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="phone"
            v-mask="phoneMask"
            :error-messages="phoneErrors"
            label="Ваш номер"
            required
            @input="$v.phone.$touch()"
            @blur="$v.phone.$touch()"
            type="tel"
            name="phone"
          ></v-text-field>
        </v-col>
      </div>
      <v-row class="pt-6">
        <v-col cols=12 class="checkbox d-flex align-center text-left">
          <v-checkbox
            dark
            id="checkboxJurist"
            v-model="checkbox"
            label="Согласен с политикой конфиденциальности"
            :error-messages="checkboxErrors"
            required
            @change="$v.checkbox.$touch()"
            @blur="$v.checkbox.$touch()"
          ></v-checkbox>
        </v-col>
        <v-col cols=12 class="mt-12">
          <div class="buttons">
            <v-btn dark color="#13bbec" @click="isActiveJurist = false" v-model="isActiveJurist">Назад</v-btn>
            <v-btn dark color="#13bbec" @click="submit">Отправить</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row class="pt-6">
        <v-col class="text-center">
          <router-link to="privacy" @click.native="goUp">политика конфиденциальности</router-link>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
  import { mask } from 'vue-the-mask'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'
  export default {
    name: 'juristForm',
    props: {
      value: Boolean
    },
    watch : {
      value(newVal){
        this.isActiveJurist = newVal
      },
      isActiveJurist(newVal) {
        this.$emit('input', newVal)
      }
    },
    directives: {mask},
    mixins: [validationMixin],
    validations: {
      OPF: { required },
      JFN: { required },
      JN: { required },
      INN: { required },
      KPP: { required },
      JA: { required },
      OGRN: { required },
      Settlement: { required },
      Bank: { required },
      BankINN: { required },
      BankOGRN: { required },
      BIK: { required },
      Correspondent: { required },
      OKVD: { required },
      OKPO: { required },
      fio: { required, maxLength: maxLength(10) },
      post: { required },
      attorney: { required },
      attorneyData: { required },
      email: { required, email },
      phone: { required, minLength: minLength(17) },
      checkbox: {
        checked (val) {
          return val
        },
      },
      validationGroupA: [
        'OPF', 'JFN', 'JN', 'INN', 'KPP', 'JA', 'OGRN', 'Settlement', 'Bank', 'BankINN', 'BankOGRN', 'BIK', 'Correspondent', 'OKVD', 'OKPO', 'checkbox'
      ],
      validationGroupB: [
        'fio', 'post', 'email', 'phone'
      ],
      validationGroupC: [
        'attorney', 'attorneyData'
      ]
    },
    data: () => (
      {
        OPF: '',
        JFN: '',
        JN: '',
        INN: '',
        KPP: '',
        JA: '',
        JA2: '',
        OGRN: '',
        Settlement: '',
        Bank: '',
        BankINN: '',
        BankOGRN: '',
        BIK: '',
        Correspondent: '',
        OKVD: '',
        OKPO: '',
        fio: '',
        post: '',
        radios: 'Устав',
        attorney: '',
        attorneyData: '',
        email: '',
        phone: '',
        phoneMask: '# (###) ###-##-##',
        checkbox: false,
        isActiveJurist: true,
        isActiveRepresentative: false,
        isActiveAttorney: false
      }
    ),
    computed: {
      OPFErrors () {
        const errors = []
        if (!this.$v.OPF.$dirty) return errors
        !this.$v.OPF.required && errors.push('Введите организационно-правовую форму')
        return errors
      },
      JFNErrors () {
        const errors = []
        if (!this.$v.JFN.$dirty) return errors
        !this.$v.JFN.required && errors.push('Введите полное наименование юр.лица')
        return errors
      },
      JNErrors () {
        const errors = []
        if (!this.$v.JN.$dirty) return errors
        !this.$v.JN.required && errors.push('Введите сокращенное наименование юр.лица')
        return errors
      },
      INNErrors () {
        const errors = []
        if (!this.$v.INN.$dirty) return errors
        !this.$v.INN.required && errors.push('Введите ИНН')
        return errors
      },
      KPPErrors () {
        const errors = []
        if (!this.$v.KPP.$dirty) return errors
        !this.$v.KPP.required && errors.push('Введите КПП')
        return errors
      },
      JAErrors () {
        const errors = []
        if (!this.$v.JA.$dirty) return errors
        !this.$v.JA.required && errors.push('Введите юридический адрес')
        return errors
      },
      OGRNErrors () {
        const errors = []
        if (!this.$v.OGRN.$dirty) return errors
        !this.$v.OGRN.required && errors.push('Введите ОГРН')
        return errors
      },
      SettlementErrors () {
        const errors = []
        if (!this.$v.Settlement.$dirty) return errors
        !this.$v.Settlement.required && errors.push('Введите рассчетный счет')
        return errors
      },
      BankErrors () {
        const errors = []
        if (!this.$v.Bank.$dirty) return errors
        !this.$v.Bank.required && errors.push('Введите наименование банка')
        return errors
      },
      BankINNErrors () {
        const errors = []
        if (!this.$v.BankINN.$dirty) return errors
        !this.$v.BankINN.required && errors.push('Введите ИНН банка')
        return errors
      },
      BankOGRNErrors () {
        const errors = []
        if (!this.$v.BankOGRN.$dirty) return errors
        !this.$v.BankOGRN.required && errors.push('Введите ОГРН банка')
        return errors
      },
      BIKErrors () {
        const errors = []
        if (!this.$v.BIK.$dirty) return errors
        !this.$v.BIK.required && errors.push('Введите БИК')
        return errors
      },
      CorrespondentErrors () {
        const errors = []
        if (!this.$v.Correspondent.$dirty) return errors
        !this.$v.Correspondent.required && errors.push('Введите корреспондентский счет')
        return errors
      },
      OKVDErrors () {
        const errors = []
        if (!this.$v.OKVD.$dirty) return errors
        !this.$v.OKVD.required && errors.push('Введите ОКВЭД')
        return errors
      },
      OKPOErrors () {
        const errors = []
        if (!this.$v.OKPO.$dirty) return errors
        !this.$v.OKPO.required && errors.push('Введите ОКПО')
        return errors
      },
      fioErrors () {
        const errors = []
        if (!this.$v.fio.$dirty) return errors
        !this.$v.fio.maxLength && errors.push('Имя не должно содержать более 10 символов')
        !this.$v.fio.required && errors.push('Введите ваше имя')
        return errors
      },
      postErrors () {
        const errors = []
        if (!this.$v.post.$dirty) return errors
        !this.$v.post.required && errors.push('Введите должность')
        return errors
      },
      attorneyErrors () {
        const errors = []
        if (!this.$v.attorney.$dirty) return errors
        !this.$v.attorney.required && errors.push('Введите номер доверенности')
        return errors
      },
      attorneyDataErrors () {
        const errors = []
        if (!this.$v.attorneyData.$dirty) return errors
        !this.$v.attorneyData.required && errors.push('Введите дату выдачи доверенности')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Введите валидный e-mail')
        !this.$v.email.required && errors.push('Введите ваше сообщение')
        return errors
      },
      phoneErrors () {
        const errors = []
        if (!this.$v.phone.$dirty) return errors
        !this.$v.phone.minLength && errors.push('Ваш номер должен содержать больше 10 цифр')
        !this.$v.phone.required && errors.push('Введите ваш контактный номер')
        return errors
      },
      checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        !this.$v.checkbox.checked && errors.push('Вы должны принять соглашение')
        return errors
      }
    },
    methods: {
      goUp: function() {
        window.scrollTo(0,0)
        this.order = false
      },
      submit () {
        if(!this.isActiveRepresentative && !this.isActiveAttorney) {
          this.$v.validationGroupA.$touch()
          if (!this.$v.validationGroupA.$invalid) {
            let formData = new FormData(document.forms.formJurist)
            fetch('mail/send.php', {
              method: 'POST',
              body: formData
            }).then(function(response){
              document.querySelector('#formJurist').innerHTML = "<h3>Ура! Ваше сообщение отправлено !</h3>"
            }).catch(function(error){
              document.querySelector('#formJurist').innerHTML = "<h3>Упс... попробуйте еще раз</h3>"
            }) 
          }
        } else if(this.isActiveRepresentative && !this.isActiveAttorney) {
          this.$v.validationGroupA.$touch()
          this.$v.validationGroupB.$touch()
          if (!this.$v.validationGroupA.$invalid && !this.$v.validationGroupB.$invalid) {
            let formData = new FormData(document.forms.formJurist)
            fetch('mail/send.php', {
              method: 'POST',
              body: formData
            }).then(function(response){
              document.querySelector('#formJurist').innerHTML = "<h3>Ура! Ваше сообщение отправлено !</h3>"
            }).catch(function(error){
              document.querySelector('#formJurist').innerHTML = "<h3>Упс... попробуйте еще раз</h3>"
            }) 
          }
        } else if(this.isActiveAttorney) {
          this.$v.validationGroupA.$touch()
          this.$v.validationGroupB.$touch()
          this.$v.validationGroupC.$touch()
          if (!this.$v.validationGroupA.$invalid && !this.$v.validationGroupB.$invalid && !this.$v.validationGroupC.$invalid) {
            let formData = new FormData(document.forms.formJurist)
            fetch('mail/send.php', {
              method: 'POST',
              body: formData
            }).then(function(response){
              document.querySelector('#formJurist').innerHTML = "<h3>Ура! Ваше сообщение отправлено !</h3>"
            }).catch(function(error){
              document.querySelector('#formJurist').innerHTML = "<h3>Упс... попробуйте еще раз</h3>"
            }) 
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  #app {
    form {
      width: 40%;
      a {
        color: #13bbec;
        font-size: 90%;
      }
      h3 {
        color: #fff;
      }
      .col-12 {
        padding: 2px 16px;
      }
      input, label {
        color: #fff;
      }
      .v-input__slot:before {
        border-color: #fff;
        &:focus {
          border-color: #fff;
        }
      }
      .buttons {
        button {
          margin: 0 1rem;
          &.hide {
            display: none;
            &.show {
              display: block;
            }
          }
        }
      }
      .representativeForm {
        display: none;
        color: #fff;
        &.show {
          display: block;
        }
      }
      .attorney {
        display: none;
        &.show {
          display: block
        }
      }
    }
  }
</style>